/* eslint-disable guard-for-in */
import React from 'react';
import styled from 'styled-components';
import { Arr } from '../../CodesForFoundation';
import { Observer } from '../../CodesThatsGottaGoSomewhereElse';
import { Store } from '../../concepts/revive/Store';
import { FrameData, Profiler } from '../../Profiler';
import { Fill } from '../../ui/Fill';

const store = Store.create({ visible: false });

type FrameReport = {
    label: string,
    values: [string, number, number][],
}[];

const compile = (data: FrameData) => {
    const report = [] as FrameReport;
    for (const sk of Object.keys(data.sections)) {
        const sd = data.sections[sk];
        const gs = {};
        const add = (label: string, time: number) => {
            if (gs[label] === undefined) gs[label] = [];
            gs[label].push(time);
        };
        for (const [d, i, o] of sd) {
            const t = o - i;
            add('Avg', t);
            add('D' + d, t);
        }
        const values = Object.keys(gs).map(n =>
            [n, gs[n].reduce((a, b) => a + b, 0) / gs[n].length, gs[n].length] as [string, number, number]);

        report.push({ label: sk, values });
    }
    return report;
};

const avgReport = (reports: FrameReport[]) => {
    const values = {} as any;

    for (const r of reports) {
        for (const s of r) {
            for (const [k, v] of s.values) {
                const x = s.label + '/' + k;
                (values[x] ?? (values[x] = [])).push(v);
            }
        }
    }

    const result = [] as FrameReport;

    for (const k of Object.keys(values)) {
        let c = Arr.last(result);
        const [s, r] = k.split('/');
        const v = values[k];
        const va = v.reduce((a, b) => a + b, 0) / v.length;

        if (!c || c.label !== s) {
            c = { label: s, values: [] };
            result.push(c);
        }

        c.values.push([r, va, v.length]);
    }

    return result;
};

const format = (report: FrameReport) => {
    if (!report) return '';
    return report.map(x =>
        [
            x.label,
            ...x.values.map(v => `  ${v[0]}: [${v[2]}] ${v[1]}ms`),
        ].join('\n'),
    ).join('\n');
};

export class ProfilerOverlay extends React.Component {

    public static toggle() {
        store.update({ visible: !store.visible });
    }

    public render() {
        return <Frame>
            <Observer store={store} render={({ visible }) => <>
                {visible && <>
                    <ReportFrame />
                </>}
            </>} />
        </Frame>;
    }
}

const ReportFrame: React.FC = () => {
    const reports = Profiler.getFrames().map(compile);
    return <Frame>
        <Data edge>{format(avgReport(reports))}</Data>
        <Data>{format(reports[reports.length - 10])}</Data>
        <Data>{format(reports[reports.length - 7])}</Data>
        <Data>{format(reports[reports.length - 4])}</Data>
        <Data>{format(reports[reports.length - 1])}</Data>
    </Frame>;
};

const Frame = styled(Fill)`
    display: flex;
    padding: 4rem 10rem;
    z-index: 10000;
    color: dimgray;
    font-size: 1.1em;
    font-family: Courier New;
    pointer-events: none;
`;

const Data = styled.pre<{ edge?: boolean }>`
    border-right: solid 2px ${p => p.edge ? 'skyblue' : 'transparent'};
    width: 30rem;
    padding: 1rem;
`;
